import { Component, inject, Input, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchStateService } from '../../shared/services/search-state.service';
import { TranslateService } from '@ngx-translate/core';
import { MonitoringService } from '../../../shared/services/monitoring/monitoring-service';
import { MCAppGatewayService } from '../../../shared/services/mcappgateway/mcappgateway.service';
import { PostGetLocationDetailsRequest } from '../../../shared/model/providerlocationsearch/PostGetLocationDetailRequest';
@Component({
  selector: 'app-provider-search-details-location-card',
  imports: [CommonModule],
  templateUrl: './provider-search-details-location-card.component.html',
  styleUrl: './provider-search-details-location-card.component.css'
})
export class ProviderSearchDetailsLocationCardComponent {

  mcAppGateway = inject(MCAppGatewayService);
  searchState = inject(SearchStateService);
 
  @Input() location: any;
  @Input() currentLocation: any = null;
  @Input() fromLocationSearch: boolean = false;

  providerDetailsLocation$ = this.searchState.providerDetailsLocation$;

  public soonAsText: string = 'AS_SOON_AS';
  public milesAwayText: string = 'DESCRIPTION';
  public scheduleText: string = 'SCHEULE';
  public today: string = 'TODAY';
  public tomorrow : string = 'TOMORROW';
  public getDirectionsLabel : string = 'GET_DIRECTIONS';
  public viewDetailBtnText: string = 'VIEW_DETAILS';  
    
  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem('locale') || 'en-US'); // Default to 'en-US' if no locale is provided
  }

  ngOnInit(): void {
    // Load translations
    this.translate.get('GET_DIRECTIONS').subscribe((translated: string) => {
        this.getDirectionsLabel = translated;
    });

    this.translate.get('MILES_AWAY').subscribe((translated: string) => {
        this.milesAwayText = translated;
    });

    this.translate.get('VIEW_DETAILS').subscribe((translated: string) => {
      this.viewDetailBtnText = translated;
    });
  }

  onGetDirections() {
    if (this.location && this.location.locationDirection) {
      window.open(this.location.locationDirection, '_blank');
    }
  }

  onViewDetails() {
    console.log('Viewing details for location:', this.location);
    
    // Implement the logic to view location details here
    this.searchState.setCurrentProviderDetailsLocation(this.location);   
    this.searchState.setShowSpinner(true);
    
    var locationDetailsRequest = new PostGetLocationDetailsRequest();
    locationDetailsRequest.locationID = this.location.locationId;
    locationDetailsRequest.latitude = this.currentLocation?.latitude || null;
    locationDetailsRequest.longitude = this.currentLocation?.longitude || null;

    this.mcAppGateway.PostGetLocationDetails(locationDetailsRequest).subscribe({
      next: (response) => {
        console.log('Location Details Response:', response);
        
        // Handle the response as needed
        this.searchState.setCurrentLocationDetails(response);
        this.searchState.setShowSpinner(false);
      },
      error: (error) => {
        console.error('Error fetching location details:', error);
        alert('An error occurred while fetching location details. Please try again later.');
        this.searchState.setShowSpinner(false);
        this.searchState.clearCurrentLocationDetails();
      }
    });
  }
}
